module.exports = __webpack_public_path__ + "img/waist.945ce19c.png";